import React from 'react';
import Hero from '../components/home/Hero';
import ServicesSection from '../components/home/ServicesSection';
import WhyUs from '../components/home/WhyUs';
import OffersAndPrime from '../components/home/OffersAndPrime';
import Testimonials from '../components/home/Testimonials';

export default function Home() {
  return (
    <>
      <Hero />
      <ServicesSection />
      <WhyUs />
      <OffersAndPrime />
      <Testimonials />
    </>
  );
}
